import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { TbMenu, TbX } from "react-icons/tb";

const HeaderRevamp = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    // Handle Scroll for sticky header
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu on route change
    useEffect(() => {
        setMobileOpen(false);
    }, [location]);

    return (
        <header className={`header-revamp-container ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="header-inner">
                    {/* Logo Section */}
                    <div className="header-logo">
                        <Link to="/">
                            <img src="assets/img/logowhite.png" alt="Abia Tech Hub" />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="desktop-nav d-none d-xl-block">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/products">Products</Link></li>
                            <li><a href="https://academy.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Academy</a></li>
                            <li><a href="https://workspace.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Workspace</a></li>
                            <li><a href="https://internet.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Internet access</a></li>
                            <li><a href="https://techflock.ng/" target="_blank" rel="noopener noreferrer">Techflock</a></li>
                            <li><a href="https://blog.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Blog</a></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    {/* Mobile Menu Toggle */}
                    <div className="mobile-toggle d-xl-none">
                        <button 
                            className="revamp-hamburger-btn" 
                            onClick={() => setMobileOpen(true)}
                            aria-label="Open Menu"
                        >
                            <TbMenu size={32} />
                        </button>
                    </div>

                    {/* Mobile Menu Overlay */}
                    <div className={`mobile-menu-overlay ${mobileOpen ? 'active' : ''}`}>
                        <div className="mobile-menu-backdrop" onClick={() => setMobileOpen(false)}></div>
                        <div className="mobile-menu-content">
                            <div className="mobile-menu-header">
                                <div className="mobile-logo">
                                    <Link to="/">
                                        <img src="assets/img/logowhite.png" alt="Abia Tech Hub" />
                                    </Link>
                                </div>
                                <button 
                                    className="close-menu-btn" 
                                    onClick={() => setMobileOpen(false)}
                                    aria-label="Close Menu"
                                >
                                    <TbX size={28} />
                                </button>
                            </div>
                            
                            <nav className="mobile-nav-links">
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about">About</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                    <li><Link to="/products">Products</Link></li>
                                    <li><a href="https://academy.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Academy</a></li>
                                    <li><a href="https://workspace.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Workspace</a></li>
                                    <li><a href="https://internet.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Internet access</a></li>
                                    <li><a href="https://techflock.ng/" target="_blank" rel="noopener noreferrer">Techflock</a></li>
                                    <li><a href="https://blog.abiatechhub.com/" target="_blank" rel="noopener noreferrer">Blog</a></li>
                                    <li><Link to="/contact">Contact</Link></li>
                                </ul>
                            </nav>

                            <div className="mobile-menu-footer">
                                <a href="mailto:hello@abiatechhub.com" className="contact-link">
                                    <i className="fal fa-envelope-open-text"></i> hello@abiatechhub.com
                                </a>
                                <a href="tel:+2348052749600" className="contact-link">
                                    <i className="fal fa-phone"></i> +234 805 274 9600
                                </a>
                                <Link to="/contact" className="theme-btn w-100 mt-3 text-center">Consultancy</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderRevamp;
